import { Alert, StepperList } from "client/CommonComponents"
import CancelConfirmationPopup from "client/CommonComponents/DialogBox/CancelConfirmationPopup"

interface Iprops {
    stepperListData: any,
    panelList: any,
    StepperRef: any
    activeStepper: any,
    handleClickCancel: any,
    handleClickNext: any,
    isButtonDisable: any,
    hideDialog: any,
    Popupcontent: any,
    purchaseOrderStepperData: any,
    dismissAlert: any,
    bulkOrderAlert: any
}
const BulkOrderAssetDetail = ({ stepperListData,
    panelList,
    StepperRef,
    activeStepper,
    handleClickCancel,
    handleClickNext,
    isButtonDisable,
    hideDialog,
    Popupcontent,
    purchaseOrderStepperData,
    dismissAlert,
    bulkOrderAlert }: Iprops) => {
    return (
        <>
            <StepperList
                stepperListData={stepperListData}
                panelList={panelList}
                className={`purchaseorder-stepper VehicleRequest-detail-fleet fleet-bulkorder fleetbulkorder_buttons px-3`}
                StepperRef={StepperRef}
                activeStepper={activeStepper}
                SelectedVehiclesCount={true}
                handleClickNext={(e?: any) => handleClickNext(e)}
                handleClickPrevious={handleClickCancel}
                catalogItemDetailsLength={activeStepper == 4 ? 0 : activeStepper}
                nextBtnText='Continue Order'
                btnBlockClassName=''
                isButtonDisable={isButtonDisable}
                isBulkOrder={true}
             data-attribute="BulkOrderAssetDetail_Default_StepperList" />
            <CancelConfirmationPopup
                hideDialog={!Popupcontent.isDialogVisible}
                onDismiss={hideDialog}
                Popupcontent={Popupcontent}
                popupOutlinebtnOnclick={() => Popupcontent?.popupOutlinebtnOnclick()}
                popupPrimarybtnOnclick={() => Popupcontent?.popupPrimarybtnOnclick()}

            />
            {bulkOrderAlert?.orderDetailId === purchaseOrderStepperData?.orderDetailId && (
                <div className="vehicle-request-stepper"><Alert
                    className="alert-message-stepper"
                    showAlert={bulkOrderAlert?.showAlert}
                    dismissAlert={dismissAlert}
                    type={bulkOrderAlert?.type}
                    text={bulkOrderAlert?.text}
                 data-attribute="BulkOrderAssetDetail_Default_Alerts" /></div>
            )}
        </>
    )
}

export default BulkOrderAssetDetail